import { Input } from "@vds/inputs";
import { Line } from "@vds/lines";
import { DropdownSelect } from "@vds/selects";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import FloorPlan from "../../global/components/floorPlan/FloorPlan";
import {
  AreaSelectContainer,
  AssignGrayContainer,
  FloorPlanContainer,
  FloorText
} from "../../global/components/OnboardingFormStyles/Styles";
import { BasicSnapshot } from "../../global/components/snapshots/BasicSnapshot";
import { getSitesAndFloorsData } from "../../global/utility/Utils";
import { snapshotImage, StreamType } from "../../hoc/snapshotImage";
import { getCameraObjectbyId } from "../../model/reportService";
import {
  setAreaSelected,
  setCamPosition,
  setUnpairedCamDetails,
} from "../../store/actions";
import { CAMERA_ONBOARDING_TEST_IDS } from "./cameraOnboardingConstants";

const AssignAreaandName = ({
  title,
  setPosition,
  setNewAreaInput,
  updateCreatingNewArea,
  editFlow
}) => {
  const dispatch = useDispatch();
  const {
    floorSelected,
    // snapshots,
    areaSelected,
    camDetails,
    selectedCameraQR,
    unpairedCamDetails,
    camPosition,
    companionSelected,
  } = useSelector((state) => state?.cameraonboardingReducer);
  const { cameraList } = useSelector((state) => state?.deviceReducer);
  const [cameraObj, setCameraObj] = useState([]);
  const [floorAreas, setFloorAreas] = useState([]);
  const [selectedValue, setSelectedValue] = useState("");
  const [newArea, setNewArea] = useState("");
  const { siteTagList } = useSelector((state) => state?.sitesReducer);
  const locationList = getSitesAndFloorsData(siteTagList);
  const allAreas = locationList?.areas;
  const fieldOfViews =
    useSelector((state) => state.cameraonboardingReducer.fovNames) || [];
  const fovIdsForSelectedCameraQA = fieldOfViews?.map((item) => item.fovId);
  useEffect(() => {
    const filteredAreas = allAreas.filter((area) =>
      area.tagids?.includes(floorSelected.id)
    );
    setFloorAreas(filteredAreas);
  }, []);

  const handleAreaChange = (e) => {
    const selectedAreaId = e.target.value;
    if (selectedAreaId !== "newAreaSelected") {
      setSelectedValue("");
    }
    if (selectedAreaId === "newAreaSelected") {
      setSelectedValue(selectedAreaId);
      dispatch(setAreaSelected({ id: "", name: selectedAreaId }));
      if (updateCreatingNewArea) {
        updateCreatingNewArea(
          selectedAreaId === "newAreaSelected",
          selectedAreaId === "newAreaSelected" ? newArea : ""
        );
      }
    } else {
      const selArearName = e.target[e.target.selectedIndex].text;
      dispatch(setAreaSelected({ id: selectedAreaId, name: selArearName }));
    }
  };

  const handleNewAreaInputChange = (e) => {
    const selectNewAreaId = e.target.value;
    setNewArea(selectNewAreaId);
    updateCreatingNewArea(true, selectNewAreaId);
    setNewAreaInput(selectNewAreaId.trim().length > 0);
  };

  const updateCamPosition = ({ top, left }) => {
    console.log(top, left);
    if (camDetails?.isPairing) {
      dispatch(setUnpairedCamDetails({ position: { top, left } }));
      setPosition({ top, left });
    } else {
      dispatch(setCamPosition({ position: { top, left } }));
      setPosition({ top, left });
    }
  };

  useEffect(() => {
    const tempCamObj = cameraList.filter(
      (item) => item.refid === selectedCameraQR
    );
    if (tempCamObj) {
      if (camPosition?.top) {
        tempCamObj[0].customdata.cameralocation.top = camPosition?.top;
      }
      if (camPosition?.left) {
        tempCamObj[0].customdata.cameralocation.left = camPosition?.left;
      }
      console.log(
        "tempCamObj >>>",
        tempCamObj,
        getCameraObjectbyId(selectedCameraQR),
        "camPosition >>>",
        camPosition
      );
      setCameraObj(tempCamObj);
    }
  }, [selectedCameraQR && cameraList, camPosition]);

  return (
    <AssignGrayContainer>
      <div style={{ display: "flex" }}>
        {fovIdsForSelectedCameraQA?.map((fovid) => {
          if(editFlow) {
          const SnapshotImg = snapshotImage(
            BasicSnapshot,
            fovid,
            selectedCameraQR,
            StreamType.PAIRED_CAMERA
          );
          return <SnapshotImg />;
        } else {
          const SnapshotImg = snapshotImage(
            BasicSnapshot,
            fovid,
            selectedCameraQR,
            StreamType.UNPAIRED_CAMERA,
            companionSelected?.id
          );
          return <SnapshotImg />;
      }})}
      </div>
      <Line type="secondary" />

      <FloorText>
        Drag and Drop the camera icon so that its location on the floor plan
        corresponds to it's location on your site. You can zoom in to the map to
        increase accuracy of placement.
      </FloorText>

      <FloorPlanContainer>
        {floorSelected && floorSelected?.imageurl ? (
          camDetails?.isPairing ? (
            <FloorPlan
              floorImage={floorSelected?.imageurl}
              isEditable={false}
              FloorSize={[728, 367]}
              unPairedCam={unpairedCamDetails}
              onChangeCamPosition={updateCamPosition}
            />
          ) : (
            // (<FloorPlan cameras={getCameraObjectbyId(selectedCameraQR)} floorImage={floorSelected?.imageurl} isEditable={true} onChangeCamPosition={updateCamPosition}/>)
            cameraObj &&
            cameraObj.length && (
              <FloorPlan
                cameras={cameraObj}
                floorImage={floorSelected?.imageurl}
                FloorSize={[728, 367]}
                isEditable={true}
                onChangeCamPosition={updateCamPosition}
              />
            )
          )
        ) : (
          <span>No floor plan selected.</span>
        )}
      </FloorPlanContainer>

      <AreaSelectContainer>
        <DropdownSelect
          label="Area"
          onChange={handleAreaChange}
          data-testid={CAMERA_ONBOARDING_TEST_IDS.ASSIGN_AREA_AND_NAME_AREA_SELECT}
          required={true}
          width="328px"
        >
          <option value="">Select area</option>
          <option value="newAreaSelected" selected={newArea}>
            Attach to a new area
          </option>
          {floorAreas?.map((area) => (
            <option
              selected={areaSelected.id === area?.id}
              key={area.id}
              value={area.id}
            >
              {area.name}
            </option>
          ))}
        </DropdownSelect>

        {selectedValue === "newAreaSelected" && (
          <Input
            width="328px"
            type="text"
            label="New area name"
            value={newArea}
            defaultValue={newArea}
            onChange={handleNewAreaInputChange}
            data-testid={CAMERA_ONBOARDING_TEST_IDS.ASSIGN_AREA_AND_NAME_NEW_AREA_INPUT}
          />
        )}
      </AreaSelectContainer>
    </AssignGrayContainer>
  );
};

export default AssignAreaandName;
